<template>
  
  <v-flex xs12 sm12 md12 class="mt-3">
    <v-card>
      <v-card-text class="mt-0">

        <BoxHeader 
          :questionObj="question" 
          title="Date Picker">
        </BoxHeader>

        <!-- Question -->
        <v-textarea 
          :counter="250"
          label="Write question here"
          v-model="questionText"
          v-on:input="setTextForQuestionObj($event)" 
          auto-grow
          autofocus
          :rules="[rules.required]"
        ></v-textarea>
      
        <v-date-picker 
          class="mt-2 elevation-0"
          v-model="pickedDate" 
          full-width 
          :reactive="true">
        </v-date-picker>

      </v-card-text>

    </v-card>
  </v-flex>

</template>

<script>
// @ is an alias to /src
import BoxHeader from '@/components/questionForms/BoxHeader.vue'

export default {
  name: "date",
  components: {
    BoxHeader
  },
  props: {
    question: Object
  },
  data: () => ({
    questionText: null,
    pickedDate : new Date().toISOString().substr(0, 10),
    rules: {
      required: value => !!value || 'Cannot Be Empty.'
    }
  }),
  computed: {
  },
  created: function(){
    this.questionText = this.question.text;
  },
  methods: {
    setTextForQuestionObj(text) {
      this.$store.commit('setTextForQuestionObj', {questionObj: this.question, text:text});
    }
  }
};
</script>

<style scoped>

</style>